/**
 * Обогащает блюда признаком отключённой печати.
 *
 * У блюда нет отдельного поля: признак «не печатать» определяется наличием
 * ID блюда в списке отключённых печатей подразделения.
 *
 * @param {Array} items - Массив элементов меню (блюда и категории)
 * @param {Array} noPrintItemIds - Список ID блюд с отключённой печатью
 * @returns {Array} - Обогащённые элементы с полем notPrint
 */
export function enrichItemsWithNoPrint(items, noPrintItemIds) {
    const noPrintSet = new Set(noPrintItemIds)

    return items.map(item => {
        if (item.type !== 'dish') {
            return item
        }
        return {
            ...item,
            notPrint: noPrintSet.has(item.id),
        }
    })
}
